<template>
  <v-container :fill-height='loading'>
    <v-layout v-if="loading"
      align-center
      justify-space-around
      wrap
      fill-height
    style="background:var(--background-grey); height:100vh;"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50">
          </v-progress-circular>
      </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <div class="add-page-head">
          <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">Clients</span>
          <span class="body-small font-weight-bold pt-1 d-block">View, search and manage your clients</span>
        </div>
      </v-flex>
      <v-flex xs12 v-if="error">
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
      <v-flex xs12>
      <div class="app-panel" :class="{'white px-1 pb-5 pt-4' : $vuetify.breakpoint.xsOnly, 'white px-3 pb-5 pt-4' : !$vuetify.breakpoint.xsOnly}">
          <v-layout :class="{'px-3 pb-3' : $vuetify.breakpoint.xsOnly, 'px-0 pb-5 ' : !$vuetify.breakpoint.xsOnly}">
            <v-flex xs8>
              <v-text-field
                append-icon="search"
                label="Search"
                single-line
                hide-details
                :autofocus="!$vuetify.breakpoint.xsOnly"
                clearable
                v-model="search"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 offset-xs1 text-xs-right>
              <create-client-modal></create-client-modal>
            </v-flex>
          </v-layout>
          <v-data-table
              :headers="headers"
              :items="clients"
              hide-actions
              :search="search"
              class="datatable"
            >
            <template slot="items" slot-scope="props">
              <tr >
                <td class="text-xs-left body-small" @click='editClient(props.item)' style="cursor: pointer;">{{ props.item.name }}</td>
                <td class="text-xs-right body-small">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                      >
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-tile
                      >
                        <v-list-tile-title @click="deleteClient(props.item)" style="cursor: pointer;">Delete</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
          <edit-client-modal :showEdit.sync='showEdit' :editingClient='editingClient'></edit-client-modal>
        </div>
      </v-flex>
  </v-layout>
  <confirm ref="confirm"></confirm>
</v-container>
</template>

<script>
import CreateClientModal from '@/components/Client/CreateClientModal'
import EditClientModal from '@/components/Client/EditClientModal'
import Confirm from '@/components/Shared/Confirm'
import firebase from 'firebase/app'
import 'firebase/database'

export default {
  components: {
    CreateClientModal,
    EditClientModal,
    Confirm
  },
  data () {
    return {
      search: '',
      pagination: {},
      headers: [
        { text: 'Name', value: 'name', align: 'left', class: 'body-2 font-weight-bold' },
        { text: '', width: '50px' }
        // { text: 'Total billed', value: 'totalBilled', align: 'center', class: 'body-2 font-weight-bold' }
      ],
      editingClient: {},
      showEdit: false
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
      // return true
    },
    clients () {
      return this.$store.getters.clients
    },
    groupId () {
      return this.$store.getters.user.group
    }
  },
  methods: {
    editClient (client) {
      this.editingClient = client
      this.showEdit = true
    },
    async deleteClient (client) {
      if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
        // this.$delete(this.invoice.lineItems, itemId)
        try {
          this.$store.commit('setLoading', true)
          await firebase.database().ref(`clients/${this.groupId}/${client.id}`).set(null)
          this.$store.commit('setLoading', false)
        } catch (error) {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        }
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
